import { BaSeParagraph } from '@base/react';
import React from 'react';

// import { Container } from './styles';

function NameRegional({ name, isActive }) {
  return (
    <div>
      <BaSeParagraph isBold color="#8B99A7">
        {name}
      </BaSeParagraph>
    </div>
  );
}

export default NameRegional;
